import * as React from "react";
import classnames from "classnames";
import "./styles.css";
interface IProps {
    active: boolean;
    msg ?: string;
}
export default function Loading(props: IProps) {
    const {active} = props;
    const containerClassName = classnames("loading-container", {active});
    return(
        <div className={containerClassName}>
            <div className="loading-box">
            { props.msg && <h4 className="msg">{props.msg}</h4>}
                <div className="loader">
                </div>
            </div> 
        </div>
    );
}
